import apiHandler from "../apiHandler";

export const getImage = async (imageId: string): Promise<string> => {
    if (!imageId) {
        throw new Error('No image ID provided');
    }

    const imageBlob = await apiHandler({
        endpoint: `/img/${imageId}`,
        method: 'GET',
        responseType: 'blob', 
    });

    if (!imageBlob) {
        throw new Error('Failed to fetch the image');
    }

    return URL.createObjectURL(imageBlob);
};